module.exports = __webpack_public_path__ + "img/sankaku_71_red.85ea4f74.png";